<template>
  <button
    class="toggle-capsule-component"
    :style="`border-color: ${border_color ? border : color}`"
    @click="$emit('toggleClicked')"
  >
    <div
      class="toggle-capsule-component-fill"
      :style="`
        background-color: ${color};
        padding-right: ${is_active ? '30px' : '10px'};
      `"
    />
    <div
      class="toggle-capsule-component-circle"
      :style="`
        border-color: ${border_color ? border : color};
        background-color: ${knob};
        margin-left: ${is_active ? '19px' : '-1px'};
      `"
    />
  </button>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
  export default {

    props: [
      'is_active', // is boolean, toggles on/off of toggle - circle left = false, circle right = true
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of main components, outlines etc.
      'border_color', // is string, contains hexadecimal value of border
      'knob_color', // is string, contains hexadecimal value of consistent knob color
    ],

    mixins: [
      TColor,
    ],

    computed: {
      color() {
        return this.getColor(this.foreground_color);
      },

      border() {
        return this.getColor(this.border_color);
      },

      knob() {
        if(this.knob_color) {
          return this.getColor(this.knob_color); // consistent color was given
        }
        else {
          if(this.is_active) {
            return this.getColor(this.background_color);
          }
          else {
            return this.color;
          }
        }
      }
    },

    data: () => ({

    }),

    methods: {

    },
  }
</script>

<style>
.toggle-capsule-component {
  width: 40px;
  height: 20px;
  border: 1px solid;
  border-radius: 10px;
  position: relative;
}
.toggle-capsule-component-fill {
  height: 20px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  position: absolute;
  top: -1px;
  left: -1px;
  transition:
    padding-right .1s linear;
}
.toggle-capsule-component-circle {
  width: 20px;
  height: 20px;
  border: 1px solid;
  border-radius: 10px;
  position: absolute;
  top: -1px;
  margin-left: -1px;
  background-color: transparent;
  transition:
    background-color .10s linear,
    margin-left .1s linear;
}
</style>
